export const ERROR_MESSAGE = "Your message is too long. Please shorten it.";
export const MAX_CHAT_LENGTH_MESSAGE = 10000;
export const SHOW_COUNTER_THRESHOLD = 0.8;
